<template>
   <div>
      <div class="marginzero heading" ><span><b>Quote</b></span></div>
      <div class="card">
         <center> <img src="../assets/quote.png"  ></center>
      </div>
      <div id="marginright">
         <div id="myBtn">
            <button   id="tabbutton" v-on:click="emailpopup()">Email</button>
            <button id="tabbutton">Print</button>
            <button id="tabbutton" @click="quoteobject.quote.tabIndex--">Back</button>
         </div>
      </div>
      <div id="myModal" class="popup">
         <div class="popup-topcontent" >
            <span>Send Email</span>
            <span class="close">x</span>
         </div>
         <div class="popup-content" id="max" >
            <center><span :style="msgcolor" class="fontsize"><b>{{message}}</b></span></center>
            <div  class="frm-group ">
               <div class="col-30 marginleft">
                  <select  v-model.trim="selected" @change="changeemail()" >
                     <option  disabled value="">Select</option>
                     <option v-for="etype in emailtype"   v-bind:key="etype.key" v-bind:value="etype.key" >{{etype.value}} </option>
                  </select>
               </div>
               <div class="col-30 marginleft">
                  <multiselect
                     style="width:100%"
                     v-model="emailid"
                     :options="emaillist"
                     :custom-label="displayname"
                     selected="selected"
                     >
                  </multiselect>
               </div>
               <div class="col-12 marginleft">
                  <input type="submit"  Value="Add" id="customerbutton" @click="retrieveemailids()">
               </div>
            </div>
            <div class="frm-group margintop">
               <div class="col-30 marginleft">
                  <label for="AdditionalEmail">Additional Email</label>
               </div>
               <div class="col-30 marginleft">
                  <input type="textbox" placeholder="Enter email Id" v-model="additionalemail" id="additionalemail" v-validate="'email'"  data-vv-name="Email"  >
                  <div v-if="errors.has('Email')" class="alert-danger" > {{ errors.first('Email') }} </div>
               </div>
               <div class="col-12 marginleft">
                  <input type="submit" Value="Add" @click="addadditionalemail()" id="customerbutton">
               </div>
            </div>
            <br><br>
            <table  class="table-month-table">
               <tr class="table-month-row">
                  <th v-for="(col,index) in colheaders" :key="index" class="table-month-header-blue"><span >{{col.header}}</span></th>
               </tr>
               <tr class="table-month-td" >
               </tr>
               <tr v-for="(emails,index) in totalemailids"  :key="index" class="table-month-row">
                  <td class="table-month-td">{{emails.name}}</td>
                  <td class="table-month-td">{{emails.type}}</td>
                  <td class="table-month-td">{{emails.email}}</td>
                  <td class="table-month-td">
                     <center><input type="submit" value="X" @click="deleteemailids(index)" id="customerbutton"></center>
                  </td>
               </tr>
            </table>
            <br><br>
            <center><input type="submit" Value="Send Email"  id="customerbutton">&nbsp;
               <input type="submit" Value="Clear" @click="clearemails"  id="customerbutton">
            </center>
         </div>
      </div>
   </div>
</template>
<script >
import httpemployee from '../js/http-employee'
import httpcustomer from '../js/http-customer.js'
import httpdeals from '../js/http-dealstracking.js'
import manageSourceSvc from '../js/http-managesource'
export default {
  props: ['quoteobject'],
  data () {
    return {
      colheaders: [{
        header: 'Name'
      },
      {
        header: 'Type'
      },
      {
        header: 'Email'
      },
      {
        header: 'Action'
      }

      ],
      emailtype: [{
        key: 'E',
        value: 'Employee'
      },
      {
        key: 'D',
        value: 'Dealer'
      },
      {
        key: 'C',
        value: 'Customer'
      }
      ],
      firstName: '',
      selected: '',
      message: '',
      emailid: '',
      dealerListForDisplay: [],
      customersList: [],
      employeeList: [],
      totalemaillist: [],
      selecttype: '',
      emaillist: [],
      totalemailids: [],
      names: '',
      additionalemail: '',
      additionalemailid: 0,
      msgcolor: {
        color: 'black'
      },
      showErrorsObject: {
        color: 'red',
        display: 'none'
      }
    }
  },
  methods: {
    fetchData () {
      this.retrieveCustomerList()
      this.getemployeenames()
      this.searchDealers()
    },

    displayname () {

    },

    changeemail () {
      if (this.selected == 'E') {
        this.emaillist = this.employeeList
        this.displayname = this.displayEmployeeFullName
      }
      if (this.selected == 'C') {
        this.emaillist = this.customersList
        this.displayname = this.displayFullName
      }

      if (this.selected == 'D') {
        this.emaillist = this.dealerListForDisplay
        this.displayname = this.displayDealerFullName
      }
    },
    retrieveemailids (value) {
      httpdeals.get('dataLinks/emaildetails', {
        params: {
          id: this.emailid.employeeId || this.emailid.customerId || this.emailid.dealerId,
          type: this.selected
        }
      }).then(response => {
        this.message = ''
        this.totalemaillist = response.data
        this.existingemailvalidation()
        this.pushemailids()
        // console.log(JSON.stringify(this.totalemaillist[0].email))
      })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },
    existingemailvalidation () {
      for (var i = 0; i < this.totalemailids.length; i++) {
        if (this.totalemailids[i].id == this.emailid.employeeId) {
          this.message = 'Email already exists. Please choose a different email id.'
          this.msgcolor.color = 'Red'
        }
        if (this.totalemailids[i].id == this.emailid.customerId) {
          this.message = 'Email already exists. Please choose a different email id.'
          this.msgcolor.color = 'Red'
        }
        if (this.totalemailids[i].id == this.emailid.dealerId) {
          this.message = 'Email already exists. Please choose a different email id.'
          this.msgcolor.color = 'Red'
        }
        if (this.totalemailids[i].email == this.additionalemail) {
          // console.log(this.totalemailids[i].email)
          // console.log(this.additionalemail)
          this.message = 'Email already exists. Please choose a different email id.'
          this.msgcolor.color = 'Red'
        }
      }
    },

    pushemailids () {
      if (this.selected == 'E') {
        this.selecttype = 'Employee'
        this.names = this.totalemaillist[0].firstName + ',' + this.totalemaillist[0].middleName + ',' + this.totalemaillist[0].lastName
      }
      if (this.selected == 'D') {
        this.selecttype = 'Dealer'
        this.names = this.totalemaillist[0].dealerName
      }
      if (this.selected == 'C') {
        this.selecttype = 'Customer'

        if (this.customerType == 'P') {
          this.names = this.totalemaillist[0].firstName + ',' + this.totalemaillist[0].middleName + ',' + this.totalemaillist[0].lastName
        } else if (this.customerType == 'B') {
          this.names = this.totalemaillist[0].businessName
        }
      }

      if (this.message == '') {
        this.totalemailids.push({
          id: this.emailid.employeeId || this.emailid.customerId || this.emailid.dealerId,
          type: this.selecttype,
          email: this.totalemaillist[0].email,
          name: this.names

        })
      }
      this.emailid = ''
    },

    deleteemailids: function (index) {
      this.totalemailids.splice(index, 1)
    },
    addadditionalemail () {
      this.message = ''
      if (this.additionalemail !== '') {
        this.$validator.validateAll().then(() => {
          if (!this.errors.any()) {
            if (this.message == '') {
              this.totalemailids.push({
                id: 'ADE' + this.additionalemailid++,
                email: this.additionalemail,
                type: 'Additional'
              })
              this.additionalemail = ''
            }
          }
        })
      }
      this.existingemailvalidation()
    },
    retrieveCustomerList (value) {
      httpcustomer.get('/customer/').then(response => {
        this.customersList = response.data
      })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },
    displayFullName (option) {
      if (option.customerType == 'P') {
        return `${option.firstName} ${option.middleName != null && option.middleName.length != 0 ? ',' + option.middleName : ''} ,${option.lastName != null && option.lastName.length != 0 ? option.lastName : ''}`
      } else if (option.customerType == 'B') {
        return `${option.businessName}`
      }
    },
    displayEmployeeFullName (option) {
      return `${option.firstName} ${option.middleName != null && option.middleName.length != 0 ? ',' + option.middleName : ''} ,${option.lastName != null && option.lastName.length != 0 ? option.lastName : ''}`
    },
    displayDealerFullName (option) {
      return `${option.dealerName}`
    },
    getemployeenames: function () {
      let searchEmployee = this.createSearchObject()
      httpemployee.post('/employee/search/', searchEmployee).then(response => {
        this.employeeList = response.data
        if (this.employeeList.length != 0) {
          this.norecordsfound = false
        } else {
          this.norecordsfound = true
        }
      })
        .catch(e => {
          this.errorslist.push(e)
        })
    },
    createSearchObject () {
      return {
        'firstName': '',
        'lastName': '',
        'roleType': '',
        'statusCode': 'A'
      }
    },
    searchDealers: function () {
      manageSourceSvc.get('/dealersearch', {
        params: {
          dealerName: '',
          statusCode: 'A'
        }
      }).then(response => {
        // console.log("Search Response: "+ JSON.stringify(response.data))
        this.dealerListForDisplay = response.data
        if (this.dealerListForDisplay.length != 0) {
          this.norecordsfound = false
        } else {
          this.norecordsfound = true
        }
      })
        .catch(e => {
          console.log('Error during search API call')
          this.norecordsfound = true
        })
    },
    clearemails () {
      this.totalemailids = []
      this.emailid = ''
      this.selected = ''
      this.additionalemail = '',
      this.errors.clear()
      this.message = ''
    },
    emailpopup () {
      var popup = document.getElementById('myModal')
      var btn = document.getElementById('myBtn')
      var span = document.getElementsByClassName('close')[0]
      btn.onclick = function () {
        popup.style.display = 'block'
      }
      span.onclick = function () {
        popup.style.display = 'none'
      }

      window.onclick = function (event) {
        if (event.target == popup) {
          popup.style.display = 'none'
        }
      }
    }

  },
  computed: {
    customerType: function () {
      var custSelect = this.emailid.customerId
      var custType = ''
      if (this.emailid.customerId != '') {
        this.customersList.forEach(customerObj => {
          if (customerObj.customerId == custSelect) {
            custType = customerObj.customerType
          }
        })
      }
      return custType
    }
  },
  mounted () {
    this.fetchData()
  }

}
</script>
<style scoped>.popup {
	display: none;
	position: fixed;
	z-index: 1;
	padding-top: 100px;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	overflow: auto;
	background-color: rgb(0, 0, 0);
	background-color: rgba(0, 0, 0, 0.4);
}

.popup-content {
	overflow: hidden;
	border: 1px solid #00529B;
	background: white;
	padding: 10px 0px 10px 10px;
	border-top: none;
	margin: 0px 250px;
	left: 0
}

.popup-topcontent {
	background-color: dodgerblue;
	margin: 0px 250px;
	padding: 10px 10px 10px 10px;
	border: 1px solid #00529B;
	font-family: Verdana, Geneva, Tahoma, sans-serif;
	font-size: 14px;
	color: white;
	margin-top: 2%;
}

.close {
	color: black;
	float: right;
	font-size: 16px;
	font-weight: bold;
	padding: 0px 10px 0px 0px;
}

.close:hover,
.close:focus {
	color: #000;
	text-decoration: none;
	cursor: pointer;
}

.floatleft {
	float: left;
	font-size: 12px;
}

.margintop {
	margin-top: 3%;
}

.marginleft {
	margin-left: 5%;
}

.additionalmarginleft {
	margin-left: 10%;
}

.frm-group {
	/** display: -webkit-flex;  **/
	display: flex;
	flex-flow: row;
	align-items: left;
	width: 100%;
}

.frm-group label {
	text-align: left;
	font-size: 12px;
	vertical-align: bottom;
	margin: 8px 15px 0px 10px;
	display: block;
	font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.frm-group input {
	width: 100%;
	padding: 6px;
	border: 1px solid #ddd;
	border-radius: 5px;
	resize: vertical;
	margin: 5px 10px 0px 0px;
}

.frm-group select {
	width: 100%;
	padding: 6px;
	border: 1px solid #ddd;
	border-radius: 5px;
	resize: vertical;
	margin: 5px 10px 0px 0px;
}

.margin20 {
	margin-left: 10%
}

.col-27 {
	float: right;
	width: 27%;
	font-size: 12px;
}

.fontsize {
	font-size: 12px;
}

#tabbutton {
	float: right;
	color: white;
	padding: 6px 20px;
	background-color: dodgerblue;
	border: 1px solid #ddd;
	margin: 10px 0px 0px 0px;
}

#marginright {
	margin-right: 10%
}

#deletebutton {
	background-color: dodgerblue;
	border: 1px solid #ddd;
	margin: 10px 0px 0px 0px;
	color: white;
	cursor: pointer;
}
@media (max-width: 800px) {
	.popup-content {
	overflow: hidden;
	border: 1px solid #00529B;
	background: white;
	padding: 10px 0px 10px 10px;
	border-top: none;
	margin: 0px 150px;
	left: 0
}

.popup-topcontent {
	background-color: dodgerblue;
	margin: 0px 150px;
	padding: 10px 10px 10px 10px;
	border: 1px solid #00529B;
	font-family: Verdana, Geneva, Tahoma, sans-serif;
	font-size: 14px;
	color: white;
	margin-top: 2%;
}
}
</style>
